<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Custom Clearance Quotation Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div v-if="checkModule.indexOf('CC') >= 0 && ccTableArryMain.length > 0">
              <!-- /.box-header v-if="ffTableArry.length>0" -->
              <div class="box-body">
                <div class="box-header">
                  <!-- <md-button
                    @click="openCC"
                    v-if="hideButtn==false"
                    class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
                  >New CC Quotation</md-button>-->
                </div>
                <div class="table-responsive tableMain">
                  <table id="cc" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr no</th>
                        <th>CC Quotation</th>

                        <th>Approval Status</th>

                        <!-- <th>Action</th> -->
                        <th>Action</th>
                        <th>Print</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item1, index) in ccTableArryMain" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td :style="index == 0 ? 'color:green' : 'color:red'">
                          <b>Quotation No. :</b>
                          {{ item1.ccQSeries }}
                          <br />
                          <b>Validity Date :</b>
                          {{ item1.validityDate | moment }}
                          <br />
                          <span class="error">{{
                            item1.ccExpireStatus == 1 ? " (Expired)" : ""
                          }}</span>
                          <br />
                          <b-button
                            v-if="collapseFFMainVisible == false"
                            @click="getMainCCId(item1.ccQId)"
                            variant="outline-primary"
                            size="sm"
                            >Show Quote</b-button
                          >
                        </td>

                        <td>
                          <b>Manager Approval :</b>
                          {{
                            item1.ccStatus == "0"
                              ? "Pending"
                              : item1.ccStatus == "1"
                              ? "Approved"
                              : "Rejected"
                          }}
                          <br />
                          <b>Client Approval :</b>
                          {{
                            item1.ccClientStatus == "0"
                              ? "Pending"
                              : item1.ccClientStatus == "1"
                              ? "Approved"
                              : "Rejected"
                          }}
                          <br />
                          <br />
                          <span v-if="item1.ccQuoteRejectCount != '0'" class="error"
                            >Note : Quote Rejected {{ item1.ccQuoteRejectCount }} Times By
                            Client.</span
                          >
                        </td>

                        <!-- <td>{{item1.clientName}}</td> -->
                        <!-- <td>
                      <md-button
                        class="md-icon-button md-raised md-dense"
                        @click="editCC(item1.ccQId)"
                      >
                        <md-icon>edit</md-icon>
                      </md-button>
                        </td>-->
                        <td
                          v-if="
                            index == '0' &&
                            item1.ccClientStatus != '2' &&
                            item1.ccClientStatus != '1'
                          "
                        >
                          <b v-if="item1.ccStatus != '1' && item1.sendHODApproveCC == '1'"
                            >Sent For Approval
                            <br />
                          </b>
                          <!-- <b
                            v-else-if="item1.ccStatus=='1' && item1.sendToEnquiryCC=='0'"
                            class="showMoreData"
                            @click="openPopEnqury(item1)"
                          >Send To Enquiry Team
                            <br>
                          </b>-->
                          <b
                            v-else-if="
                              item1.ccStatus == '1' && item1.sendToEnquiryCC == '1'
                            "
                            >Sent to Enquiry
                            <br />
                          </b>
                          <b v-else
                            >N/A
                            <br />
                          </b>
                        </td>
                        <td v-else>
                          <b>
                            {{
                              item1.ccClientStatus == "2" && index == 0
                                ? "Client Rejected"
                                : item1.ccClientStatus == "1" && index == 0
                                ? "Client Approved"
                                : "N/A"
                            }}
                            <br />
                          </b>
                        </td>
                        <td>
                          <span v-if="item1.MainEnquiryQuotationCCCreated">{{ item1.MainEnquiryQuotationCCCreated }}</span><br/>
                          <span v-if="item1.MainEnquiryQuotationCCUpdated">{{ item1.MainEnquiryQuotationCCUpdated }}</span><br/>
                          <span v-if="item1.MainEnquiryQuotationCCApprovedBy">{{ item1.MainEnquiryQuotationCCApprovedBy }}</span><br/>
                          <md-button
                            v-if="
                              item1.ccQuotationPdf != '' && item1.ccQuotationPdf != null
                            "
                            class="md-icon-button md-raised md-dense"
                            @click="Print(item1.ccQuotationPdf)"
                          >
                            <md-icon>print</md-icon>
                          </md-button>
                          <b v-else>Pdf Not Generated</b>
                          <div v-if="!isHidden">
                            <date-picker
                              style="margin-top: 8px"
                              lang="en"
                              :format="selectDateFormat"
                              id="validityDate"
                              name="validityDate"
                              :not-before="min"
                              :not-after="max"
                              v-model="item1.validityDate"
                            ></date-picker>
                            <!-- hide hideMe  -->
                            <span class="error" v-if="!item1.validityDate">{{
                              errorModal.validityDate
                            }}</span>
                            <!-- hide hideMe  -->

                            <b-button
                              class="smbutnWidth"
                              style="margin-top: 8px"
                              variant="primary"
                              size="sm"
                              id="updateValidityDate"
                              @click="
                                updateValidityDate(
                                  item1.validityDate,
                                  item1.ccQId,
                                  this.mainCCtableIdForCC,
                                  'CC',
                                  (quotationTill = 0),
                                  (prevalidityDate = item1.validityDate)
                                )
                              "
                              >Update</b-button
                            >
                          </div>

                          <b-button
                            v-if="item1.ccExpireStatus == 1"
                            class="smbutnWidth"
                            style="margin-top: 8px"
                            variant="primary"
                            size="sm"
                            id="QutationValidityhide"
                            @click="QutationValidityhide(item1.validityDate, isHidden)"
                            >Qutation Extends</b-button
                          >
                          <br /><span id="QutationValidityhide_err"></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- /.box-body -->
              </div>
            </div>
            <div>
              <b-collapse id="collapseFFMain" v-model="collapseFFMainVisible">
                <div>
                  <div>
                    <b-card class="gutr">
                      <b-row>
                        <b-col md="3">
                          <md-layout md-flex="25">
                            <label>Quotation Validity Date</label>
                            <!-- <date-picker
                              :disabled="mainCCtableIdForCC ? true : false"
                              lang="en"
                              :format="selectDateFormat"
                              id="validityDate"
                              name="validityDate"
                              :not-before="new Date()"
                              v-model="mainModal.validityDate"
                            ></date-picker> -->
                            <b-form-input
                                :disabled="mainCCtableIdForCC ? true : false"
                                :formatter="capitalizeAll"
                                v-model="mainModal.validityDate"
                                type="date"
                                placeholder="Enter Billing Start Date"
                                :min="calculateMinDate()"
                                :max="calculateMaxDate()"
                                :not-before="new Date()"
                              ></b-form-input>
                            <span class="error" v-if="!mainModal.validityDate">{{
                              errorvalidityDate
                            }}</span>
                          </md-layout>
                        </b-col>
                        <b-col md="3">
                          <md-layout md-flex="100">
                            <label for="quoRate">Quotation Remarks</label>

                            <b-form-input
                              :formatter="capitalizeAll"
                              id="quoRate"
                              name="quoRate"
                              v-model="mainModal.quotation_remark"
                            ></b-form-input>
                          </md-layout>
                        </b-col>
                        <b-col md="3">
                          <md-layout
                            md-flex="35"
                            v-if="
                              mainModal.sendHODApproveCC == '1' &&
                              this.$sessionsStorage.get('userLevel') == '1'
                            "
                          >
                            <label for="transportType">Manager Approval Status</label>
                            <model-list-select
                              :isDisabled="mainModal.ccClientStatus == '1' ? true : false"
                              :list="statusList"
                              v-model="mainModal.ccStatus"
                              option-value="statusV"
                              option-text="statusT"
                              placeholder="Select Status"
                            ></model-list-select>
                          </md-layout>
                        </b-col>
                        <b-col md="3">
                          <md-layout
                            md-flex="10"
                            v-if="mainModal.sendHODApproveCC == '1'"
                          >
                            <!-- :disabled="buttonDisable" -->
                            <b-button
                              class="smbutnWidth"
                              style="margin-top: 45px"
                              variant="primary"
                              size="sm"
                              id="addButtonLoader4"
                              @click="addGenerateQuotation('4')"
                              >Update</b-button
                            >
                            <md-spinner
                              md-indeterminate
                              id="loader4"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </b-col>
                      </b-row>
                      <!-- <md-layout md-gutter >
                        <md-layout md-flex="25">
                          <label>Quotation Validity Date</label>
                          <date-picker
                            :disabled="mainCCtableIdForCC ? true : false"
                            lang="en"
                            :format="selectDateFormat"
                            id="validityDate"
                            name="validityDate"
                            :not-before="new Date()"
                            v-model="mainModal.validityDate"
                          ></date-picker>
                          <span class="error" v-if="!mainModal.validityDate">{{
                            errorvalidityDate
                          }}</span>
                        </md-layout>
                         <md-layout
                              md-flex="20"
                            >
                              <md-layout md-flex="100">
                                <label for="quoRate">Quotation Remarks</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="quoRate"
                                  name="quoRate"
                                  v-model="mainModal.quotation_remark"
                                ></b-form-input>
                              </md-layout>
                            </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout
                          md-flex="35"
                          v-if="
                            mainModal.sendHODApproveCC == '1' &&
                            this.$sessionsStorage.get('userLevel') == '1'
                          "
                        >
                          <label for="transportType"
                            >Manager Approval Status</label
                          >
                          <model-list-select
                            :isDisabled="
                              mainModal.ccClientStatus == '1' ? true : false
                            "
                            :list="statusList"
                            v-model="mainModal.ccStatus"
                            option-value="statusV"
                            option-text="statusT"
                            placeholder="Select Status"
                          ></model-list-select>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout
                          md-flex="10"
                          v-if="mainModal.sendHODApproveCC == '1'"
                        >
                          <b-button
                            class="smbutnWidth"
                            style="margin-top: 45px"
                            variant="primary"
                            size="sm"
                            id="addButtonLoader4"
                            @click="addGenerateQuotation('4')"
                            >Update</b-button
                          >
                          <md-spinner
                            md-indeterminate
                            id="loader4"
                            style="display: none"
                          ></md-spinner>
                        </md-layout>
                      </md-layout> -->
                    </b-card>

                    <b-navbar
                      variant="light"
                      type="light"
                      style="background: white !important"
                      class="gutr ml-3"
                    >
                      <b-navbar-nav>
                        <div v-if="ccTableArry.length > 0">
                          <b-button-group>
                            <b-button
                              v-if="mainModal.ccStatus!=1"
                              size="sm"
                              class="pull-left"
                              variant="outline-dark"
                              @click="visibleMFF = !visibleMFF"
                            >
                              <span v-if="visibleMFF == true">Close</span>
                              <span v-else>New Entry</span>
                            </b-button>
                          </b-button-group>
                        </div>
                      </b-navbar-nav>
                      <b-navbar-nav class="ml-auto">
                        <div v-if="ccTableArry.length > 0">
                          <b-button-group>
                            <b-button
                              v-if="
                                mainCCtableIdForCC != '' &&
                                mainModal.ccStatus != '1' &&
                                mainModal.ccClientStatus != '2' &&
                                mainModal.sendHODApproveCC != '1'
                              "
                              size="sm"
                              class="pull-right"
                              variant="outline-dark"
                              @click="openPop"
                              >Send For Aproval
                              <md-icon icon="envelope">email</md-icon>
                            </b-button>
                          </b-button-group>
                        </div>
                      </b-navbar-nav>
                    </b-navbar>

                    <div>
                      <b-collapse id="collapseMiddle" v-model="visibleMFF" class="mt-2">
                        <b-card class="gutr">
                          <md-layout md-gutter>
                            <md-layout md-flex="50" class="pr-2 pl-2"  v-if="shipmentType == '1'">
                              <label for="transportType">Container Type *</label>
                              <model-list-select
                                :list="containerTypeList"
                                v-model="ccModal.containerTypeId"
                                option-value="containerTypeId"
                                option-text="containerType"
                                placeholder="Select Type"
                              ></model-list-select>
                              <span class="error" v-if="!ccModal.containerTypeId">{{
                                blankConTypeError
                              }}</span>
                            </md-layout>
                            <!-- <md-layout md-flex="5"></md-layout> -->
                            <md-layout
                              md-flex="50"
                              class="pr-2 pl-2"
                              v-if="ccModal.ccTableId == ''"
                            >
                              <label for="ccList">Particulars *</label>
                              <model-list-select 
                                      :list="$store.getters['common/getAllLedgerList']" 
                                      v-model="ccModal.ledgerId"
                                      @input="getPartiName"
                                      option-value="ledgerId" 
                                      option-text="ledger" 
                                      placeholder="Select Particular">
                                      </model-list-select>
                              <!-- <model-list-select
                                @input="getPartiName"
                                :list="ledgerData"
                                v-model="ccModal.ledgerId"
                                option-value="ledgerId"
                                option-text="ledger"
                                placeholder="Select Particulars"
                              ></model-list-select> -->
                              <span class="error" v-if="!ccModal.ledgerId">{{
                                errorccModal.ledgerId
                              }}</span>
                            </md-layout>
                            <md-layout md-flex="50" class="pr-2 pl-2" v-else>
                              <label for="ccList">Particulars *</label>
                              <model-list-select
                                isDisabled
                                :list="ledgerData"
                                v-model="ccModal.ccType"
                                option-value="ledger"
                                option-text="ledger"
                                placeholder="Select Type"
                              ></model-list-select>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="labelMargtop">
                            <!-- <md-layout md-flex="40"></md-layout> -->
                            <md-layout md-flex="50" class="pr-2 pl-2">
                              <b-form-checkbox
                                id="checkbox-1"
                                v-model="particularStatus"
                                name="checkbox-1"
                                value="1"
                                unchecked-value="0"
                                >Charges As Per Receipt</b-form-checkbox
                              >
                            </md-layout>
                          </md-layout>
                          <div v-if="particularStatus == '0'">
                            <md-layout md-gutter>
                              <!-- <md-layout md-flex="40"></md-layout> -->

                              <md-layout md-flex="25" class="pr-2 pl-2">
                                <md-layout md-flex="100">
                                  <label for="sellingRate">Buy In Rate *</label>

                                  <b-form-input
                                    :formatter="capitalizeAll"
                                    type="number"
                                    id="ccSellingRate"
                                    name="ccSellingRate"
                                    v-model="ccModal.ccBuyingRate"
                                  ></b-form-input>
                                  <span class="error" v-if="!ccModal.ccBuyingRate">{{
                                    blankbuyinError
                                  }}</span>
                                </md-layout>
                              </md-layout>
                              <!-- <md-layout md-flex="5"></md-layout> -->

                              <md-layout md-flex="25" class="pr-2 pl-2">
                                <md-layout md-flex="100">
                                  <label for="sellingRate">Selling Rate *</label>

                                  <b-form-input
                                    :formatter="capitalizeAll"
                                    type="number"
                                    id="ccSellingRate"
                                    name="ccSellingRate"
                                    v-model="ccModal.ccSellingRate"
                                  ></b-form-input>
                                  <span class="error" v-if="!ccModal.ccSellingRate">{{
                                    blankSellingError
                                  }}</span>
                                </md-layout>
                              </md-layout>
                              <!-- <md-layout md-flex="5"></md-layout> -->

                              <md-layout md-flex="25" class="pr-2 pl-2">
                                <label for="transportType">Currency *</label>
                                <model-list-select
                                  :list="currencyList"
                                  v-model="ccModal.currency"
                                  option-value="currencyV"
                                  option-text="currencyT"
                                  placeholder="Select"
                                ></model-list-select>
                                <span class="error" v-if="!ccModal.currency">{{
                                  blankcurrencyError
                                }}</span>
                              </md-layout>
                              <!-- <md-layout md-flex="5"></md-layout> -->

                              <md-layout
                                md-flex="25"
                                class="pr-2 pl-2"
                                v-if="particularStatus == '0'"
                              >
                                <label for="transportType">Units *</label>
                                <model-list-select
                                  :list="unitList"
                                  v-model="ccModal.unit"
                                  option-value="unitId"
                                  option-text="unitName"
                                  placeholder="Select"
                                ></model-list-select>
                                <!-- <span
                                  class="error"
                                  v-if="!tptTableModal.currency"
                                >{{blankcurrencyError}}</span>-->
                              </md-layout>
                            </md-layout>
                          </div>
                          <md-layout md-gutter>
                            <!-- <md-layout md-flex="40"></md-layout> -->

                            <md-layout md-flex="25" class="pr-2 pl-2">
                              <label for="transportType">Terms</label>
                              <model-list-select
                                :list="termList"
                                v-model="ccModal.terms"
                                option-value="tV"
                                option-text="tT"
                                placeholder="Select"
                              ></model-list-select>
                              <!-- <span
                                  class="error"
                                  v-if="!tptTableModal.currency"
                              >{{blankcurrencyError}}</span>-->
                            </md-layout>
                            <md-layout md-flex="100">
                              <md-layout md-flex="100">
                                <label for="sellingRate">Special Remarks</label>

                                <b-form-textarea
                                  :formatter="capitalizeAll"
                                  id="sellingRate"
                                  name="sellingRate"
                                  v-model="ccModal.line_wise_remark"
                                ></b-form-textarea>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="50"></md-layout>
                            <md-layout md-flex="25" class="justify-content-left pr-2">
                              <b-button
                                class="smbutnWidth"
                                size="sm"
                                style="margin-top: 40px"
                                variant="primary"
                                id="addButtonLoader3"
                                :disabled="
                                  $sessionsStorage.get('designation') == 'Admin' &&
                                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                                    ? false
                                    : buttonDisable
                                "
                                @click="addGenerateQuotation('3')"
                                >{{
                                  ccModal.ccTableId == "" ? "Add" : "Update"
                                }}</b-button
                              >
                              <md-spinner
                                md-indeterminate
                                id="loader3"
                                style="display: none"
                              ></md-spinner>
                            </md-layout>

                            <b-col lg="12">
                              <span
                                class="error pull-right"
                                v-if="ccModal.MainEnquiryQuotationCCCreated"
                              >
                                <b> {{ ccModal.MainEnquiryQuotationCCCreated }}</b>
                              </span>
                            </b-col>

                            <b-col lg="12">
                              <span
                                class="error pull-right"
                                v-if="ccModal.MainEnquiryQuotationCCUpdated"
                              >
                                <b> {{ ccModal.MainEnquiryQuotationCCUpdated }}</b>
                              </span>
                            </b-col>
                            <!-- <b-col lg="12"> {{ ccModal }} </b-col> -->
                          </md-layout>
                        </b-card>
                      </b-collapse>
                    </div>
                  </div>

                  <!-- /.box-header v-if="ffTableArry.length>0" -->
                  <div class="box-body gutr" v-if="ccTableArry.length > 0">
                    <!-- <div class="box-header">
              <h5 class="box-title">Existing CC Quotation</h5>
                    </div>-->
                    <div class="table-responsive tableMain">
                      <table id="cc" class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr no</th>

                            <th v-if="shipmentType == '1'">Container Type</th>
                            <th>Particulars</th>
                            <th>Buy In Rate</th>
                            <th>Selling Rate</th>
                            <th>Unit</th>
                            <th>Special Remarks</th>

                            <th>Action</th>
                            <th>Delete</th>

                            <!-- <th>Client Name</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in ccTableArry" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td v-if="shipmentType == '1'">
                              {{ item1.containerType }}
                            </td>
                            <td>{{ item1.ccType }}</td>
                            <td>{{ item1.ccBuyingRate }} {{ item1.currency }}</td>
                            <td>{{ item1.ccSellingRate }} {{ item1.currency }}</td>
                            <td>
                              {{ item1.unitName ? item1.unitName : "NA" }}
                            </td>
                            <td>
                              {{ item1.line_wise_remark ? item1.line_wise_remark : "NA" }}
                            </td>
                            <!-- <td>{{item1.clientName}}</td> -->
                            <td>
                              <md-button
                                :disabled="item1.ccClientStatus == '2'"
                                class="md-icon-button md-raised md-dense"
                                @click="editCC(item1)"
                              >
                                <md-icon>edit</md-icon>
                              </md-button>
                            </td>
                            <td>
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="deleteTPT(item1)"
                              >
                                <md-icon>delete</md-icon>
                              </md-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>-->
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-snackbar
      :md-position="vertical + ' ' + horizontal"
      ref="snackbar"
      :md-duration="duration"
    >
      <span>{{ snackbarData }}</span>
    </md-snackbar>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";

import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType:this.$route.query.JobType,
        ShipmentType:this.$route.query.ShipmentType,
        ModuleType:this.$route.query.ModuleType,
        isLedgerActive:'1',
      })
    );
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      errorModal: {
        validityDate: "",
      },
      arrayErrorModal: {
        validityDate: "Select Date",
      },
      prevalidityDate: "",
      isHidden: true,
      max: "",
      min: "",
      selectDateFormat,
      termList: [
        {
          tV: "Collect",
          tT: "Collect",
        },
        {
          tV: "Prepaid",
          tT: "Prepaid",
        },
      ],
      unitList: [],
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,
      snackbarData: "",
      newData: {
        ccQId: "",
        mainEnquiryId: "",
        ccQSeries: "",
        ccQuotationPdf: "",
      },
      docURL: URL_BASE_DOC,
      blankConTypeError: "",
      blankbuyinError: "",
      blankSellingError: "",
      blankcurrencyError: "",
      particularStatus: "0",
      mainCCtableIdForCC: "",
      visibleMFF: false,
      collapseFFMainVisible: false,
      isLoading: "",
      openTPTDiv: false,
      openFFDiv: false,
      openCCDiv: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      containerTypeList: [],
      ledgerData: [],
      ENQHODMAIL: [],
      sumTotalCC: [],
      tptModal: {
        tptQId: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: "",
      },
      ffModal: {
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: "",
      },
      shipmentType: "",
      mainModal: {
        mainEnquiryId: "",
        enquiryClientId: "",
        ccQId: "",
        ccStatus: "",
        ccClientStatus: "",
        validityDate: "",
        ccExpireStatus: "",
        sendHODApproveCC: "",
        quotation_remark: "",
      },
      errorvalidityDate: "",
      ccModal: {
        unit: "",
        terms: "Collect",
        ccBuyingRate: "",
        containerTypeId: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        ccTableId: "",
        ccQId: "",
        ccType: "",
        ledgerId: "",
        ccSellingRate: "",
        ccStatus: "",
        ccClientStatus: "",
        ccQSeries: "",
        currency: "",
        line_wise_remark: "",
        MainEnquiryQuotationCCUpdated: "",
        MainEnquiryQuotationCCCreated: "",
      },

      errorccModal: {
        ledgerId: "",
        // ccSellingRate: "",
        // currency: ""
      },
      arrayErrorccModal: {
        ledgerId: "Select cc type",
        // ccSellingRate: "Enter rate",
        // currency: "Select Currency"
      },

      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],

      checkModule: [],
      enquiryArry: [],
      tptTableArry: [],
      ffTableArry: [],
      ccTableArry: [],
      sortConArry: [],
      ccTableArryMain: [],
      ccArryMail: [],
      shippingList: [],
      tempffTableArry: [],
      ffShipArry: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.sendHODApproveCC == "1" ? true : false;
    },
  },

  methods: {
    getPartiName() {
      let Arry = this.ledgerData.filter((x) => {
        return x.ledgerId == this.ccModal.ledgerId;
      });
      if (Arry.length > 0) {
        this.ccModal.ccType = Arry[0].ledger;
      } else {
        this.ccModal.ccType = "";
      }
    },
    // openPopEnqury(item) {
    //   Object.keys(this.newData).map(x => {
    //     this.newData[x] = item[x] || "";
    //   });

    //  this.sendMailEnq();
    // },
    sendMailEnq() {
      this.newData["jobType"] = "CC";

      this.isLoading = true;

      if (this.validate != false) {
        // $("#addButtonLoaderS").css("display", "none");
        // $("#loaderS").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/sendForClientTPT_VP.php`,
          data: JSON.stringify(this.newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            // $("#loaderS").css("display", "none");
            // $("#addButtonLoaderS").css("display", "block");

            this.isLoading = false;
            // this.getData();
            // this.$router.push({
            //   path: "/viewMainEnquiryDetails/viewMainEnquiryDetails"
            // });
          })
          .catch((error) => {});
      }
    },
    Print(item) {
      if(!item) return;
      this.openSignedDocument(`CC_QUOTATION_PDF/${item}`);
    },
    getMainCCId(MAINCCID) {
      this.mainCCtableIdForCC = MAINCCID;
      this.getData();
      this.collapseFFMainVisible = true;
    },
    // deleteTPT(item) {
    //   let paylod = {
    //     tableName: "mainccqtable",
    //     tableId: "ccTableId",
    //     tableVal: item.ccTableId,
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Enquiry/deletePermanent.php`,
    //     data: JSON.stringify(paylod),
    //     crossDomain: true,
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };
    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if (status == 200 && data) {
    //         this.getData();
    //       }
    //     })
    //     .catch((error) => {});
    // },
    deleteTPT(item) {
      this.itemObj = item;
      this.itemObj.isCCActive = item.isCCActive == "1" ? 0 : 1;
      let payload = {
        tableName: "mainccqtable",
        tableId: "ccTableId",
        tableIsActive: "isCCActive",
        value1: this.itemObj.isCCActive,
        tableVal: item.ccTableId,
        isMailSend: "No",
        manual: "No",
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
        });
    },
    sendMail(type) {
      if (type != "cancel") {
        let listCC = [];
        if (this.shipmentType == "1") {
          this.ccTableArry = [];

          for (let s = 0; s < this.containerTypeList.length; s++) {
            let arrySort = this.sortConArry.filter((x) => {
              return x.containerType == this.containerTypeList[s].containerType;
            });

            if (arrySort.length > 0) {
              listCC.splice(s, 0, arrySort);
              this.ccTableArry.push(...arrySort);
            } else {
              console.log("container not in Quote");
            }
          }
        }

        let list = [];
        let list2 = [];
        if (this.tempffTableArry.length > 0) {
          this.tempffTableArry.map((x) => {
            let i = list.indexOf(x.ffType + x.containerType);
            if (i < 0) {
              list.push(x.ffType + "<br>" + x.containerType);
            }
          });

          let unique = list.filter((item, i, ar) => ar.indexOf(item) === i);

          let newList = [];

          unique.map((x) => {
            let obj = {
              type: x,
            };
            console.log(x, obj);

            this.ffShipArry.map((y, index) => {
              let array1 = this.tempffTableArry.filter((z) => {
                return (
                  z.ffShippingWiseId == y.ffShippingWiseId &&
                  z.ffType + "<br>" + z.containerType == x
                );
              });

              if (array1.length > 0) {
                obj["s" + (index + 1)] = array1[0].ffSellingRate;
                obj["b" + (index + 1)] = array1[0].buyingRate;
                obj["conType"] = array1[0].containerType;
                obj["currency" + (index + 1)] = array1[0].currency;
              } else {
                obj["s" + (index + 1)] = "-";
                obj["b" + (index + 1)] = "-";
                obj["conType"] = "";
                obj["currency" + (index + 1)] = "";
              }
            });

            newList.push(obj);
          });
          if (this.shipmentType == "1") {
            for (let p = 0; p < this.containerTypeList.length; p++) {
              let arrySort1 = newList.filter((x) => {
                return x.type.split("<br>")[1] == this.containerTypeList[p].containerType;
              });

              if (arrySort1.length > 0) {
                list2.splice(p, 0, arrySort1);
              } else {
                console.log("container not in Quote");
              }
            }
          }
        }
        this.isLoading = true;

        let newData = {
          ccQId: this.mainCCtableIdForCC,
          mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          ccQSeries: this.ccModal.ccQSeries,
          jobType: "CC",
          MainCCQ: this.ccArryMail[0],
          MainCCTableQ: this.shipmentType == "1" ? listCC : this.ccTableArry,
          MainEnq: this.enquiryArry[0],
          sumTotal: this.sumTotalCC,
          hodMails: this.ENQHODMAIL,
          MainFFShip: this.ffShipArry,
          table: list2,
          validityDate: this.mainModal.validityDate,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForApprovalTPT_VP.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              this.snackbarData = "Mail Sent For Approval";

              this.$refs.snackbar.open();
              this.isLoading = false;
              this.getData();
              // this.$router.push({
              //   path: "/mainEnquiry/viewMainEnqQuotationCC"
              // });
            })
            .catch((error) => {});
        }
      }
    },
    openPop() {
      if (this.ccModal.validityDate == "") {
        return false;
      }
      if (this.shipmentType == "1") {
        let sameConType = [];
        this.containerTypeList.map((x) => {
          let sameCon = this.ccTableArry.filter((y) => {
            return (
              y.containerTypeId == x.containerTypeId && y.containerType == x.containerType
            );
          });
          if (sameCon.length > 0) {
            sameConType.push(sameCon);
          }
        });

        if (sameConType.length != this.containerTypeList.length) {
          this.confirm.contentHtml =
            "<h5 class='error'>INCOMPLETE QUOTE</h5>All Containers Type Requested are not added yet in this Quotation.<br> Send Incomplete Quote for Approval..?";
        } else {
          this.confirm.contentHtml = "Send  Quote for Approval..?";
        }
      } else {
        this.confirm.contentHtml = "Send  Quote for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    openTPT() {
      this.openTPTDiv = true;
    },
    openFF() {
      this.openFFDiv = true;
    },
    openCC() {
      this.openCCDiv = true;
    },

    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.tptModal.driverExp) * parseFloat(this.tptModal.travelDur);

      let averageTrucknew =
        parseFloat(this.tptModal.distance) / parseFloat(this.tptModal.mileage);

      let dieselRatenew =
        parseFloat(averageTrucknew) * parseFloat(this.tptModal.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.tptModal.toll);
      this.tptModal.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.tptModal.baseCost) * parseFloat(this.tptModal.margin)) / 100;
      let finalSalesCost2 = finalSalesCost + parseFloat(this.tptModal.baseCost);
      this.tptModal.quotRate = finalSalesCost2.toFixed(2);
    },
    validateCCQuotation(ID) {
      let validateNew = true;

      if (ID == "3") {
        if (this.ccModal.containerTypeId == "" && this.shipmentType == "1") {
          this.blankConTypeError = " Select Container Type";
          validateNew = false;
        } else {
          this.blankConTypeError = "";
        }
        if (this.particularStatus == "0") {
          if (this.ccModal.ccBuyingRate == "") {
            this.blankbuyinError = "Enter Buying Rate";
            validateNew = false;
          } else {
            this.blankbuyinError = "";
          }
          if (this.ccModal.ccSellingRate == "") {
            this.blankSellingError = "Enter Selling Rate";
            validateNew = false;
          } else {
            this.blankSellingError = "";
          }
          if (this.ccModal.currency == "") {
            this.blankcurrencyError = " Select Currency";
            validateNew = false;
          } else {
            this.blankcurrencyError = "";
          }
        }

        Object.keys(this.errorccModal).map((x) => {
          if (this.ccModal[x] == "") {
            console.log('this.ccModal=>',this.ccModal,x)
            this.errorccModal[x] = this.arrayErrorccModal[x] || "";
            validateNew = false;
          } else {
            this.errorccModal[x] = "";
          }
        });
      }

      if (validateNew) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addGenerateQuotation(ID) {
      if (this.particularStatus == 1) {
        this.ccModal.ccBuyingRate = "Charges As Per Receipt";
        this.ccModal.ccSellingRate = "Charges As Per Receipt";
        this.ccModal.currency = "";
      }
      this.validateCCQuotation(ID);

      if (ID == "3") {
        if (this.mainModal.validityDate == "") {
          this.errorvalidityDate = "Select Validity Date";
          return false;
        } else {
          this.errorvalidityDate = "";
        }
      }

      // this.validateFFExport();

      this.mainModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");
      this.mainModal["ccQId"] = this.mainCCtableIdForCC;

      let newData = {
        mainModal: this.mainModal,
        CCModal: this.ccModal,
        buttonId: ID,
      };
      console.log(newData,this.validate);

      if (this.validate != false) {
        $("#addButtonLoader" + ID).css("display", "none");
        $("#loader" + ID).css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainCCQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            // if (ID == "3") {
            //   this.ccModal.currency = "";
            //   Object.keys(this.ccModal).map(x => {
            //     this.ccModal[x] = "";
            //   });
            // }
            if (
              this.mainCCtableIdForCC == "" ||
              this.mainCCtableIdForCC == null ||
              this.mainCCtableIdForCC == undefined
            ) {
              this.mainCCtableIdForCC = data.ccQId;
              console.log(this.mainCCtableIdForCC);
            }
            $("#addButtonLoader" + ID).css("display", "block");
            $("#loader" + ID).css("display", "none");
            this.getData();
            if (ID == "3") {
              this.ccModal.ccSellingRate = "";
              this.ccModal.ccBuyingRate = "";
              this.ccModal.ccType = "";
              this.ccModal.line_wise_remark = "";
              this.ccModal.ledgerId = "";
              this.ccModal.ccTableId = "";
              this.ccModal.MainEnquiryQuotationCCUpdated = "";
              this.ccModal.MainEnquiryQuotationCCCreated = "";
              this.particularStatus = "0";

              // Object.keys(this.ccModal).map(x => {
              //   this.ccModal[x] = "";
              // });
            }

            this.snackbarData = "Data Submitted Succesfully";

            this.$refs.snackbar.open();
          })
          .catch((error) => {});
      }
    },
    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/mainEnquiry/viewMainEnqQuotationCC"
      // });
    },

    // JqueryFun() {
    //   return $(function() {
    //     $("#tpt").DataTable();
    //     $("#ff").DataTable();
    //     $("#cc").DataTable();
    //   });
    // },

    editCC(item) {
      Object.keys(this.ccModal).map((x) => {
        this.ccModal[x] = item[x];
      });
      this.visibleMFF = true;
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
        ccQId:
          this.mainCCtableIdForCC != "" || this.mainCCtableIdForCC != undefined
            ? this.mainCCtableIdForCC
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.mainModal.enquiryClientId = data.enquiryData[0].clientId;
              this.shipmentType = data.enquiryData[0].shipmentType;

              this.checkModule = data.enquiryData[0].jobType.split(",");
            } else {
              this.enquiryArry = [];
            }
            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }
            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.ENQHODMAIL.length > 0) {
              this.ENQHODMAIL = data.ENQHODMAIL;
            } else {
              this.ENQHODMAIL = [];
            }

            if (data.containerMaster.length > 0) {
              for (let q = 0; q < data.containerMaster.length; q++) {
                if (data.containerMaster[q].containerTypeId == "16") {
                  data.containerMaster[q].containerType = "20" + "'" + " STD";
                  data.containerMaster[q].containerTypeId = "1";
                }
              }
              this.containerTypeList = data.containerMaster;
            } else {
              this.containerTypeList = [];
            }
            if (data.sumTotalCC.length > 0) {
              this.sumTotalCC = data.sumTotalCC;
            } else {
              this.sumTotalCC = [];
            }

            if (data.ccData.length > 0) {
              this.ccTableArryMain = data.ccData;
              let arryStatus = this.ccTableArryMain.filter((x) => {
                return (
                  x.ccStatus == "1" && x.ccClientStatus != "2" && x.sendToEnquiryCC != 1
                );
              });

              if (arryStatus.length > 0) {
                this.newData.ccQId = arryStatus[0].ccQId;
                this.newData.mainEnquiryId = arryStatus[0].mainEnquiryId;
                this.newData.ccQSeries = arryStatus[0].ccQSeries;
                this.newData.ccQuotationPdf = arryStatus[0].ccQuotationPdf;
                this.sendMailEnq();
              }

              // let arryStatus = this.ccTableArry.filter(x => {
              //   return x.ccClientStatus == "1";
              // });

              // if (arryStatus.length > 0) {
              //   this.hideButtn = true;
              // }
            } else {
              this.ccTableArryMain = [];
              this.collapseFFMainVisible = true;
              this.visibleMFF = true;
            }

            if (data.ccTableData.length > 0) {
              this.ccTableArry = data.ccTableData;
              this.sortConArry = data.ccTableData;
            } else {
              this.ccTableArry = [];
            }
            if (data.ccStatusData.length > 0) {
              this.mainModal.validityDate = data.ccStatusData[0].validityDate;
              this.mainModal.quotation_remark = data.ccStatusData[0].quotation_remark;
              this.mainModal.sendHODApproveCC = data.ccStatusData[0].sendHODApproveCC;
              this.mainModal.ccExpireStatus = data.ccStatusData[0].ccExpireStatus;
              this.ccArryMail = data.ccStatusData;
            }
            if (data.ccStatusData.length > 0) {
              this.mainModal.ccStatus = data.ccStatusData[0].ccStatus;
              this.ccModal.ccQSeries = data.ccStatusData[0].ccQSeries;
              this.mainModal.ccClientStatus = data.ccStatusData[0].ccClientStatus;
            }

            // if (data.slineDetails.length > 0) {
            //   this.shippingList = data.slineDetails;
            // }
            if (data.fflastData.length > 0) {
              this.tempffTableArry = data.fflastData;
            }
            if (data.ffShipData.length > 0) {
              this.ffShipArry = data.ffShipData;
            } else {
              this.ffShipArry = [];
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    // By Priyanshu Singh 24/12/2021 Start
    dateDifference(pre_validityDate, current_date) {
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010

      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    currentDate() {
      var currentDate = new Date();
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      return currentDateWithFormat;
    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    dateRestriction(pre_validityDate) {
      const today = new Date(pre_validityDate);
      const minDate = new Date(today);
      // minDate.setMonth(minDate.getMonth()); // one Months
      // minDate.setDate(dateNo);
      const maxDate = new Date(today);
      // maxDate.setMonth(maxDate.getMonth() + 1); // one Months
      this.min = minDate;
      // this.max = maxDate;
      // alert(getDate);
      // alert(minDate);
      // alert(maxDate);
    },
    QutationValidityhide(pre_validityDate, isHidden) {
      this.dateRestriction(pre_validityDate);
      $("#QutationValidityhide_err").text("");
      let current_date = this.currentDate();
      // current_date = '2022-08-04';
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010
      let days_count = 0;
      if (date2 >= date1) {
        days_count = this.dateDifference(pre_validityDate, current_date);
      } else {
        days_count = 0;
      }
      // alert(days_count);
      // let days_count = 46;
      if (
        this.$sessionsStorage.get("designation") != "Admin" &&
        this.$sessionsStorage.get("nameUser") != "Bhavneesh"
      ) {
        if (days_count > 45) {
          this.isHidden = true;
          this.errorModal.validityDate =
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed";
          $("#QutationValidityhide_err").text(
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed"
          );
          // console.log("Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed");
        } else {
          if (isHidden == false) {
            this.isHidden = true;
          } else if (isHidden == true) {
            this.isHidden = false;
          } else {
            this.isHidden = false;
          }
        }
      } else {
        if (isHidden == false) {
          this.isHidden = true;
        } else if (isHidden == true) {
          this.isHidden = false;
        } else {
          this.isHidden = false;
        }
      }
    },
    updateValidityDate(validityDate, ccQId, maintptId, quot_type, pre_validityDate) {
      console.log("validityDate=>", validityDate);
      console.log("ccQId=>", ccQId);
      console.log("maintptId=>", maintptId);
      console.log("quot_type=>", quot_type);
      console.log("pre_validityDate=>", pre_validityDate);
      let current_date = this.currentDate();
      let days_count = this.dateDifference(pre_validityDate, current_date);
      Object.keys(this.errorModal).map((x) => {
        if (this.ffModal[x] == "") {
          this.errorModal[x] = this.arrayErrorModal[x] || "";
          validateNew = false;
        } else {
          this.errorModal[x] = "";
        }
      });
      if (this.validateNew != false) {
        let paylod = {
          tableName: "mainccquotation",
          fk_quot_id: ccQId, //this.$sessionsStorage.get("editTPTQId") maintptId this.ffModal.tptQId
          fk_mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          validityDate: this.convert(validityDate),
          quot_type: quot_type,
          pre_validityDate: pre_validityDate,
        };
        // console.log(paylod);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/AddValidityDateTrack.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            console.log(result);
            console.log("priyanshu");
            if (status == 200 && data) {
              if (data.status == false) {
                $("#QutationValidityhide_err").text(data.msg);
              } else if (data.status == true) {
                this.QutationValidityhide(this.convert(validityDate), false);
                this.getData();
              }
            } else if (status && data) {
            }
          })
          .catch((error) => {});
      }
    }, // By Priyanshu Singh 24/12/2021 End
    calculateMinDateBak() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let minDate;

      // If the current date is before April 1st, set minDate to April 1st of the previous year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        minDate = new Date(currentYear - 1, 3, 1);
      } else {
        // Otherwise, set minDate to April 1st of the current year
        minDate = new Date(currentYear, 3, 1);
      }

      return minDate.toISOString().split('T')[0];
    },
    calculateMaxDateBak() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let maxDate;

      // If the current date is before April 1st, set maxDate to March 31st of the current year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        maxDate = new Date(currentYear, 2, 31);
      } else {
        // Otherwise, set maxDate to March 31st of the next year
        maxDate = new Date(currentYear + 1, 2, 31);
      }

      return maxDate.toISOString().split('T')[0];
    },
    calculateMinDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let minDate;

      // Determine the start of the financial year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        minDate = new Date(currentYear - 1, 3, 1);
      } else {
        minDate = new Date(currentYear, 3, 1);
      }

      // Ensure the minimum date is today if today is within the financial year
      if (currentDate > minDate) {
        minDate = currentDate;
      }

      return minDate.toISOString().split('T')[0];
    },
    calculateMaxDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let maxDate;

      // Determine the end of the financial year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        maxDate = new Date(currentYear, 2, 32);
      } else {
        maxDate = new Date(currentYear + 1, 2, 32);
      }

      return maxDate.toISOString().split('T')[0];
    }
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// mainEnqQuotationCC.vue?3556af3d